export default "__VITE_ASSET__bMIzb55m__"